import './SignalOverview.scss';
import { Col, Image, Row } from 'antd';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';

import ReviewRawData from './ReviewRawData';

const SignalOverview = ({
  score,
  nightly,
  unitId,
  setScore,
  testId,
  recordingId,
}: {
  score: string;
  nightly: NightlyResponse;
  unitId: string;
  setScore: (value: string) => void;
  testId?: string;
  recordingId?: string;
}) => {
  const { t } = useTranslation();

  const colors = [
    { label: t('nightly.res-e'), value: 'recolor' },
    { label: t('nightly.dis'), value: 'dcolor' },
  ];
  return (
    <StyledCard
      id="nightly-signal-label"
      title={
        <div className="signaltitle">
          {t('nightly.signal-label', { night: nightly.night })}
          {!!unitId && (
            <ReviewRawData
              score={score}
              setScore={setScore}
              unitId={unitId}
              night={nightly.night}
              testId={testId}
              recordingId={recordingId}
            />
          )}
        </div>
      }>
      <div>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div className={cx('signallegend', 'signalflex')}>
              {colors.map((el) => {
                return (
                  <div className="legend-item" key={el.label}>
                    <div className={cx('legendbox', el.value)}></div>
                    <div>{el.label}</div>
                  </div>
                );
              })}
            </div>
          </Col>
          <Col span={24}>
            {
              <Image
                preview={false}
                src={score === '3' ? nightly?.images?.spo2 : nightly?.images?.spo2_4}
              />
            }
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            {
              <Image
                preview={false}
                src={score === '3' ? nightly?.images?.ppg : nightly?.images?.ppg_4}
              />
            }
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            {
              <Image
                preview={false}
                src={score === '3' ? nightly?.images?.pr : nightly?.images?.pr_4}
              />
            }
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            {
              <Image
                preview={false}
                src={score === '3' ? nightly?.images?.activity : nightly?.images?.activity_4}
              />
            }
          </Col>
        </Row>
      </div>
    </StyledCard>
  );
};

export default SignalOverview;
